<!-- Header One Component -->
<app-header-one #headerOne [footer]="footer" class="spinner"></app-header-one>

<!-- Loader -->

<div id="loader1" *ngIf="collections.length == 0">
  <div style="height: 743px;">
    <div class="preloader">
      <div class="loader">
        <div class="loaderzig">
          <div class="loader__part loader__part--1"></div>
          <div class="loader__part loader__part--2"></div>
          <div class="loader__part loader__part--3"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Home slider start-->
<section class="p-0">
  <app-slider [sliders]="sliders" [textClass]="'text-center'" [category]="catId" [buttonText]="'shop now'"
    [advImg]="Small_AdvImg">
  </app-slider>
</section>


<!-- collection banner start-->
<section class="pb-0" id="bannerimage">
  <div class="container">
    <div class="row partition2">
      <div class="col-md-6" *ngFor="let collection of collections">
        <a (click)="routecollect(collection.categoryId)" [routerLink]="['/shop/cakes/collection']"
          [queryParams]="{ category: collection.categoryId}">
          <div class="collection-banner p-right text-center">
            <img [src]="collection.imgurl" class="img-fluid" alt="collection-banner">
            <div class="contain-banner">
              <div class="ribbon">
                <h2 [ngStyle]="{'color': collection.f2_color}">{{collection.Pdesc}}
                </h2>
                <h4 style="margin-top: 10px;" [ngStyle]="{'color': collection.f1_color}">{{collection.Pname}}
                </h4>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>








<!-- Product slider start-->
<div id="premiumproducts" class="title1 section-t-space" *ngIf="Homeproducts.length > 0">
  <h4>special offer</h4>
  <h2 class="title-inner1">Premium Products</h2>
</div>
<div class="container" *ngIf="Homeproducts.length > 0">
  <div class="row">
    <div class="col-lg-6 offset-lg-3">
      <div class="product-para">
        <p class="text-center">
          Each slice of our premium cakes is a masterpiece, combining rich flavors and the finest ingredients to elevate
          your celebrations. Whether it's a birthday, anniversary, or any special occasion, indulge in the sweetness of
          perfection and make your moments unforgettable!
        </p>
      </div>
    </div>
  </div>
</div>
<section id="carouselimage" class="section-b-space p-t-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <owl-carousel-o class="product-m no-arrow" [options]="ProductSliderConfig">
          <ng-container *ngFor="let product of Homeproducts | slice:0:16">
            <ng-template carouselSlide>
              <div class="product-box">
                <app-product-box-one [ecomproduct]="product" [currency]="productService?.Currency" [thumbnail]="true"
                  [cartModal]="true">
                </app-product-box-one>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>

<section class="p-0" *ngFor="let back of BackGround" id="fullbanner">
  <div class="full-banner parallax-banner1 parallax text-center p-left"
    [style.background-image]="'url(' + back.imgurl + ')'">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="banner-contain">
            <h3 [ngStyle]="{'color': back.f1_color}">{{back.Pyear}}</h3>
            <h3 [ngStyle]="{'color': back.f1_color}">{{back.Pname}}</h3>
            <h4 [ngStyle]="{'color': back.f2_color}">{{back.Pdesc}}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> <br> <br>

<!-- <div class="container"> -->
<div class="reel-container">
  <h2 class="reel-heading">Baked with Love, Shared with Joy</h2>
  <p class="reel-headings">“Where every reel is a reason to smile — and maybe crave cake!”</p> <br> <br>

  <div class="reel-carousel">
    <button class="scroll-button left" (click)="scrollPrev()">&#10094;</button>

    <div class="slide-reel-wrapper">
      <div class="slide-reel">
        <div class="reel-card" *ngFor="let reelsvideos of reelsvideo" (click)="getReelsVideobyId(reelsvideos.id)">
          <div class="collection-banners text-center">
            <!-- <ng-container *ngIf="isVideo(reelsvideos.thumbnail)"> -->
            <ng-container>


              <div class="video-wrapper">
                <div class="view-count-overlay">
                  <i class="fa fa-eye"></i> {{ reelsvideos.views | number }}
                </div>
                <img #videoPlayer src="{{reelsvideos.thumbnail}}" alt=""
                  style="object-fit:cover;width: 255px;    height: inherit;">
                <video #videoPlayer class="reel-media" muted (click)="togglePlay(videoPlayer, playBtn)">
                  <source [src]="reelsvideos.thumbnail" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                <div class="video-controls">
                  <button class="icon-button" (click)="toggleMute(videoPlayer, $event)">
                    <i [ngClass]="videoPlayer.muted ? 'fa fa-volume-mute' : 'fa fa-volume-up'"></i>
                  </button>

                  <div>
                    <button class="icon-button" (click)="shareReel(reelsvideos, $event)">
                      <i class="fa fa-share-alt"></i>

                    </button>
                    <div class="share-count-overlay">
                      {{ reelsvideos.shares | number }}
                    </div>
                  </div>
                </div>

                <div #playBtn class="play-button">&#9654;</div>
              </div>

            </ng-container>

            <div class="contain-banners">
              <h4 style="
      font-size: medium;
      background-color: #ff4c3b;
      border-radius: 30px;
      margin-bottom: 20px;
      width: fit-content;
      padding: 4px 10px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    ">
                {{ reelsvideos.Pname }} {{reelsvideos.f1_color}}
              </h4>
            </div>

          </div>
        </div>
      </div>
    </div>

    <button class="scroll-button right" (click)="scrollNext()">&#10095;</button>
  </div>
</div>

<!-- Video Popup Modal -->
<div class="reel-modal-overlay" *ngIf="showPopup" (click)="closePopup()">
  <div class="reel-modal-content" (click)="$event.stopPropagation()">
    <video class="popup-reel-media" autoplay controls muted>
      <source [src]="activeVideoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <button class="close-button" (click)="closePopup()">×</button>
  </div>
</div>
<!-- </div> -->
<br> <br>

<!-- <app-newsletter></app-newsletter> -->
<app-footer-one [Categorysdata]="Categorys" [footer]="footer"></app-footer-one>{{Category}}

<div style="display: none;" id="preloaderfas">
  <div id="loaderfas">
    <div class="loaderzig">
      <div class="loader__part loader__part--1"></div>
      <div class="loader__part loader__part--2"></div>
      <div class="loader__part loader__part--3"></div>
    </div>
  </div>
</div>